import { SET_CATEGORY_TEMPLATE_TEXT } from "../../Actions/ActionConstants";

function categoryTemplateTexts(state=null,action){
    switch (action.type) {
        case SET_CATEGORY_TEMPLATE_TEXT:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default categoryTemplateTexts